// extracted by mini-css-extract-plugin
module.exports = {"recommendedVlogTile":"RecommendedVlogTile_recommendedVlogTile__ax6XX","image":"RecommendedVlogTile_image__P6486","title":"RecommendedVlogTile_title__0J_7v"};